import { Box, Center } from '@chakra-ui/react';
import { Sortable } from '@diamond/shared/ui';
import { Text } from '@diamond/shared/ui';
import type { FieldArrayWithId } from 'react-hook-form';

type ProductListProps = {
  isFetching: boolean;
  fields: FieldArrayWithId<any, 'products', 'id'>[];
  items: { id: string; children: React.ReactNode }[];
  onMove: (from: number, to: number) => void;
  onReorder: (result: any) => void; // DropResult, kept loose to avoid import bloat
  onRemove: (index: number, productId: string) => void;
};

export function ProductList({
  isFetching,
  fields,
  items,
  onMove,
  onReorder,
  onRemove,
}: ProductListProps) {
  return (
    <Box id="form-highlight-list" aria-label="Daftar produk highlight">
      {!isFetching && fields.length > 0 && (
        <Sortable
          handleReorderIndex={onMove}
          handleChange={onReorder}
          data={items}
          sortableCardProps={{
            padding: 0,
            border: 0,
            shadow: 'none',
            bgColor: 'transparent',
          }}
        />
      )}
      {!isFetching && fields.length === 0 && (
        <Center py="8">
          <Text color="gray.500" fontSize="sm">
            Belum ada produk yang dipilih
          </Text>
        </Center>
      )}
    </Box>
  );
}
